module.exports = __webpack_public_path__ + "static/innovative-b135877ced04ffaa18e227cda663e26b.png";